module.exports = __webpack_public_path__ + "0f6d9563ed03037d8cef232679c7eca3.MP3";